import React from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

import WelcomeLayout from "../../components/welcome/WelcomeLayout";
import BrandStep from "../../components/welcome/BrandStep";

const WelcomeRoutes = ({ authenticated }) => {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route index element={<Navigate to="brand/" replace />} />
      <Route element={<WelcomeLayout authenticated={authenticated} />}>
        <Route
          path="brand/*"
          element={
            <BrandStep
              onComplete={() => navigate("/brand/overview/", { replace: true })}
            />
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="brand/" replace />} />
    </Routes>
  );
};

export default WelcomeRoutes;
